import { useState } from "react";
import type { CategoryFilterFormState } from "../category.types";
import {
  CategoryStatusFilter,
  WeightGainCurveFilter,
} from "../utils/category.utils";

export function useFilterForm() {
  const [filterForm, setFilterForm] = useState<CategoryFilterFormState>({
    searchText: "",
    categoryStatus: CategoryStatusFilter.Active,
    weightGainCurveFilter: WeightGainCurveFilter.All,
  });

  const handleChangeFilter = <T extends keyof CategoryFilterFormState>(
    field: T,
    value: CategoryFilterFormState[T]
  ) => {
    setFilterForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    filterForm,
    handleChangeFilter,
  };
}
